import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

// Modulo de avisos (notificaciones del afiliado).
// OJO: no confundir con `store/notificaciones.js`, que maneja snackbars,
// overlay y loading globales. Este modulo solo guarda el listado de avisos.
export default ({
    namespaced: true,

    state: {
        avisos: [],
    },

    getters: {
        avisos(state) {
            return state.avisos
        },
        // Alimenta el badge del menu de usuario: solo cuenta los no leidos.
        cantidadAvisosNoLeidos(state) {
            return state.avisos.filter(aviso => aviso.leida === false).length
        },
        avisosHabilitados() {
            return process.env.VUE_APP_AVISOS === 'true'
        }
    },

    mutations: {
        setAvisos(state, payload) {
            state.avisos = Array.isArray(payload) ? payload : []
        },
    },

    actions: {
        //POST -> portal/avisos (el nroafi lo deriva el back del JWT, no se manda)
        async obtenerAvisos({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/avisos',
                withCredentials: false,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
            })
                .then((response) => {
                    // La API del portal a veces devuelve el array directo y a veces
                    // envuelto en `message`. Contemplamos los dos formatos.
                    const datos = response.data
                    const listado = Array.isArray(datos)
                        ? datos
                        : (datos && datos.message) || []
                    commit('setAvisos', listado)
                })
                .catch((error) => {
                    commit('setAvisos', [])
                    dispatch('notificaciones/showSnack', {
                        message: 'No pudimos obtener tus notificaciones.',
                        type: '400',
                    }, { root: true })
                })
                .finally(() => {
                    dispatch('auth/setSktLoader', false, { root: true })
                })
        },
    },
})
